import { AuthService } from "@/services/auth-service";

export class UblS3UploadedFile {
	ID:number = 0;
	FileName:string = "";
	MinDate:Date = new Date();
	MaxDate:Date = new Date();
	Message:string = "";
	BookYear:number = 0;
	PublicKey:string = "";
	IsPurchaseArchive:boolean = false;
	TimeCreated:Date;
	DocumentCount:number = 0;
	SentAt:Date | null = null;
	SentTo:string = "";
	LastDownloadedAt:Date | null = null;
	DownloadCount:number | null = null;
	AccountantDownloadedAt:Date | null = null;
	AccountantDownloadCount:number | null = null;

	public constructor(data:any){
		this.ID = data.ID;
		this.FileName = data.FileName;
		this.MinDate = new Date(data.MinDate);
		this.MaxDate = new Date(data.MaxDate);
		this.Message = data.Message;
		this.BookYear = data.BookYear;
		this.PublicKey = data.PublicKey;
		this.IsPurchaseArchive = data.IsPurchaseArchive || false;
		this.TimeCreated = new Date(data.TimeCreated);
		this.DocumentCount = data.DocumentCount;
		this.SentAt = data.SentAt ? new Date(data.SentAt) : null;
		this.SentTo = data.SentTo || "";
		this.LastDownloadedAt = data.LastDownloadedAt ? new Date(data.LastDownloadedAt) : null;
		this.DownloadCount = data.DownloadCount != null ? data.DownloadCount : null;
		this.AccountantDownloadedAt = data.AccountantDownloadedAt ? new Date(data.AccountantDownloadedAt) : null;
		this.AccountantDownloadCount = data.AccountantDownloadCount != null ? data.AccountantDownloadCount : null;
	}

	public get isTracked():boolean {
		return this.DownloadCount != null || this.AccountantDownloadCount != null || this.SentAt != null;
	}

	public getPublicLink():string{
		return  `${location.protocol}//${location.host}/ubl-archive-url/${AuthService.wfDossier.id}/${this.PublicKey}`;
	}
}